export default __webpack_public_path__ + "static/media/tracker.fce67eee.png";